
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 17","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"d":"m13.5 10.5 1.998 2-1.998 2m0-12 2 2m0 0-2 2m2-2h-1.533c-2.837 0-5.435 1.636-6.343 4-.907 2.364-3.287 4.087-6.124 4.087m13.981-.087h-1.516c-1.838 0-3.573-.655-4.761-1.798M1.573 4.445c1.823 0 3.471.698 4.658 1.824","stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    